export function markdownToHTML(markdown) {
    // Convert headings (e.g., "# Heading" to <h1>Heading</h1>)
    markdown = markdown.replace(/^(#{1,6})\s+(.*)$/gm, (match, hashes, content) => {
        const level = hashes.length;
        return `<h${level}>${content.trim()}</h${level}>`;
    });

    // Convert bold text (**bold** or __bold__)
    markdown = markdown.replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>');

    // Convert italic text (*italic* or _italic_)
    markdown = markdown.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');

    // Convert inline code (`code`)
    markdown = markdown.replace(/`([^`]+)`/g, '<code>$1</code>');

    // Convert links [text](url)
    markdown = markdown.replace(/$begin:math:display$([^$end:math:display$]+)]$begin:math:text$([^)]+)$end:math:text$/g, '<a href="$2">$1</a>');

    // Wrap paragraphs:
    // Split content by two or more newlines, and wrap each block in <p> tags if it doesn't already start with a block-level tag.
    markdown = markdown.split(/\n{2,}/).map(block => {
        if (/^<\/?(h[1-6]|ul|ol|li|p|blockquote|pre|code|div|section)/.test(block.trim())) {
            return block;
        }
        return `<p>${block.trim()}</p>`;
    }).join('\n\n');

    return markdown;
}
